<template>
   <div v-if="checkPermission(c_permission)">
    <b-button style="white-space: nowrap;" @click.prevent="$emit('click')" size="sm" variant="link" :disabled="loading">
        <i class="appEdit" :class="{'fa fa-pencil-square-o fa-fw' : !loading, 'fa fa-spinner fa-spin fa-fw' : loading}"
           aria-hidden="true"></i>
        <slot></slot>
    </b-button>
   </div>
</template>

<script>
    export default {
        name: "AppEdit",
        props: {
            loading: {
                type: Boolean,
                default: false
            },
            c_permission: {
                type: Number
            }
        }
    }
</script>

<style scoped>
</style>
